module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    on: {
      "click": _vm.start
    }
  }, [_vm._v("Inizia")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f505e0aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OptionsPane.vue
// module id = 36
// module chunks = 1